export const CHART_HEIGHT = "73px";

export const EMPTY_DIFFERENCE = 0.065;

export const TIME_PERIOD = "WoW";
